<template>
  <div class="login-wrapper">
    <el-card class="login-box result-card">
      <div class="icon-wrapper">
        <svg v-if="success" class="icon success-icon" aria-hidden="true">
          <use xlink:href="#icon-chenggong"></use>
        </svg>
        <svg v-else class="icon error-icon" aria-hidden="true">
          <use xlink:href="#icon-cuowu"></use>
        </svg>
      </div>

      <div class="result-header">
        <h2 class="accountinfo">{{ success ? '激活成功' : '激活失败' }}</h2>
        <p class="email-display">账号：{{ this.$store.state.account || '未知账号' }}</p>
      </div>

      <div class="notice-box" :class="success ? 'success-box' : 'error-box'">
        <template v-if="success">
          <p class="main-notice">您的账号已成功激活！</p>
          <p class="sub-notice">现在可以返回登录页面使用账号。</p>
        </template>
        <template v-else>
          <p class="main-notice">激活链接已失效或异常</p>
          <p class="sub-notice">请检查是否重复激活，或重新注册获取新邮件。</p>
        </template>
      </div>

      <div class="action-area">
        <el-button type="primary" class="back-btn" @click="background">
          {{ success ? '返回登录页面' : '返回重试' }}
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import "../../assets/fonts/iconfont.js";
import "../../assets/fontsss/iconfont.js";
export default {
  data(){
    return{
      success: false,
    }
  },
  created(){
    this.getToken()
  },

  methods:{
    background(){
      this.$router.push('/login')
    },
    async getToken(){
      try {
        const result = await this.$http.get(`activeAgent/?token=${this.$route.query.token}`)
        if(result.data.meta.status == 200){
          this.success = true
        }else{
          this.success = false
        }
      } catch (err) {
        this.success = false
      }
    }
  }
};
</script>

<style lang="less" scoped>
.login-wrapper {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  box-sizing: border-box;
}

.login-box {
  width: 420px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  border: none;
  padding: 20px;
  text-align: center;
}

.icon-wrapper {
  margin-top: 20px;
  .icon {
    width: 80px;
    height: 80px;
    margin: 0 auto;
    display: block;
  }
  .success-icon { fill: #67c23a; }
  .error-icon { fill: #f56c6c; }
}

.result-header {
  margin: 20px 0;
  .accountinfo {
    font-size: 24px;
    color: #303133;
    margin-bottom: 8px;
    font-weight: 600;
  }
  .email-display {
    font-size: 15px;
    color: #909399;
  }
}

.notice-box {
  border-radius: 8px;
  padding: 15px;
  margin: 20px 0;
  text-align: left;
  
  .main-notice {
    font-weight: bold;
    margin-bottom: 5px;
    font-size: 14px;
  }
  .sub-notice {
    font-size: 13px;
    line-height: 1.6;
  }
}

.success-box {
  background-color: #f0f9eb;
  border: 1px solid #e1f3d8;
  .main-notice { color: #67c23a; }
  .sub-notice { color: #85ce61; }
}

.error-box {
  background-color: #fef0f0;
  border: 1px solid #fde2e2;
  .main-notice { color: #f56c6c; }
  .sub-notice { color: #fab6b6; }
}

.action-area {
  margin-bottom: 10px;
  .back-btn {
    width: 100%;
    height: 42px;
    font-size: 16px;
    border-radius: 8px;
  }
}

@media screen and (max-width: 768px) {
  .login-wrapper {
    background: #ffffff;
    align-items: flex-start;
    padding-top: 10vh;
  }
  .login-box {
    width: 100%;
    box-shadow: none;
  }
}
</style>